"use strict";

var _toConsumableArray = require("/root/builder-configuration/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageCollectionFields = exports.textField1 = exports.NoRefFields = exports.simpleTextField = exports.pureTextField = exports.textTypeAndColorField = exports.notFieldForImport = exports.nonExportField = exports.stringLinkField = exports.mixedField = exports.normalTextField = exports.hiddenFormField = exports.stringField = exports.BelongsSelectOptionFields = exports.BelongsCreatedByRefField = exports.DefaultPrivateField = exports.TextTypeFields = exports.dateField = exports.MultiSelectOptionFields = exports.SelectOptionFields = exports.ImageUrlFields = exports.textEmailPasswordField = exports.hashCodeFieldText = exports.systemHideField = exports.textNumberField = exports.timeSlotPicker = exports.passwordBooleanField = exports.hiddenField = exports.byFields = exports.booleanUrlField = exports.largeTextNumberField = exports.passwordUrlField = exports.linkField = exports.numberTextField = exports.exportHideField = exports.uuidField = exports.passwordField = exports.emailField = exports.systemDateField = exports.FileUrlFields = exports.URLFields = exports.ImageFields = exports.ReferenceCreatedByFields = exports.BelongsToReferenceField = exports.childDataField = exports.OptionTypeFields = exports.fieldType = exports.crudKeys = exports.defaultFields = exports.FieldTypes = void 0;
exports.filterIndexFields = exports.filterFieldsForPlaceholderModal = exports.filterFieldsForItemTemplate = exports.filterFieldForItemTemplate = exports.filterSystemCreatedFieldsForItemList = exports.filterFieldsForItemList = exports.filterFieldsForDataTable = exports.fieldToShow = exports.filterFieldForCommandObj = exports.filterFieldsForForm = exports.collectionDefaultFieldSortOrder = exports.AllSelectOptionFields = exports.nonReferenceField = exports.level3ReferenceField = exports.notFieldForExport = exports.level3ReferenceField2 = exports.belongsToAndHiddenField = exports.systemAndRefField = exports.placeholderField = exports.StringFields = exports.referenceTextField = void 0;
/**
 * Collection of all available field types in the system
 * Each field type defines its properties, validation rules, and display settings
 */
exports.FieldTypes = {
  text: {
    id: "text",
    name: "Text",
    validation: {
      min: 1,
      max: 20
    },
    show: true,
    compositeKey: true,
    sortOrder: 0
  },
  large_text: {
    id: "large_text",
    name: "Large Text",
    validation: {
      min: 20,
      max: 140
    },
    show: true,
    compositeKey: false,
    sortOrder: 3
  },
  number: {
    id: "number",
    name: "Number",
    validation: {
      min: 20,
      max: 140
    },
    show: true,
    compositeKey: true,
    sortOrder: 1
  },
  date: {
    id: "date",
    name: "Date",
    show: true,
    compositeKey: true,
    sortOrder: 2
  },
  password: {
    id: "password",
    name: "Password",
    show: true,
    compositeKey: false,
    sortOrder: 5
  },
  color: {
    id: "color",
    name: "Color",
    show: true,
    compositeKey: false
  },
  file: {
    id: "file",
    name: "File",
    show: true,
    compositeKey: false,
    multipleTrueName: "Files/Images",
    sortOrder: 9
  },
  reference: {
    id: "reference",
    name: "Reference",
    show: true,
    compositeKey: true,
    multipleTrueName: "Multi Reference",
    sortOrder: 10
  },
  belongsTo: {
    id: "belongsTo",
    name: "Child Of",
    show: true,
    compositeKey: true,
    sortOrder: 11
  },
  image: {
    id: "image",
    name: "Image",
    show: false,
    compositeKey: false
  },
  multi_image: {
    id: "multi_image",
    name: "Multi-image",
    show: false,
    compositeKey: false
  },
  video_link: {
    id: "video_link",
    name: "Video link",
    show: false,
    compositeKey: false
  },
  url: {
    id: "url",
    name: "URL",
    show: true,
    compositeKey: true,
    sortOrder: 8
  },
  tel: {
    id: "tel",
    name: "Phone Number",
    show: true,
    compositeKey: true,
    sortOrder: 6
  },
  email: {
    id: "email",
    name: "Email",
    show: true,
    compositeKey: true,
    sortOrder: 7
  },
  boolean: {
    id: "boolean",
    name: "Boolean",
    show: true,
    compositeKey: false,
    sortOrder: 4
  },
  createdAt: {
    id: "createdAt",
    name: "Created At",
    show: false,
    compositeKey: false
  },
  updatedAt: {
    id: "updatedAt",
    name: "Updated At",
    show: false,
    compositeKey: false
  },
  createdBy: {
    id: "createdBy",
    name: "Created By",
    show: false,
    compositeKey: true
  },
  updatedBy: {
    id: "updatedBy",
    name: "Updated By",
    show: false,
    compositeKey: true
  },
  version: {
    id: "version",
    name: "Version",
    show: false,
    compositeKey: true
  },
  isDeleted: {
    id: "isDeleted",
    name: "Is deleted",
    show: false,
    compositeKey: false
  },
  dynamic_option: {
    id: "dynamic_option",
    name: "Dynamic Option",
    show: true,
    compositeKey: true,
    multipleTrueName: "Multiple Dynamic Options",
    sortOrder: 14
  },
  static_option: {
    id: "static_option",
    name: "Static Option",
    show: true,
    compositeKey: true,
    multipleTrueName: "Multiple Static Options",
    sortOrder: 15
  },
  uuid: {
    id: "uuid",
    name: "Id",
    show: false,
    compositeKey: false
  },
  custom_uuid: {
    id: "custom_uuid",
    name: "Custom UUID",
    prepend: "",
    append: "",
    algorithm: "",
    show: true,
    sortOrder: 12,
    compositeKey: false
  },
  object: {
    id: "object",
    name: "Object",
    show: false,
    sortOrder: 0,
    compositeKey: false
  },
  unix_timestamp: {
    id: "unix_timestamp",
    name: "Unix Timestamp",
    validation: {
      min: 20,
      max: 140
    },
    show: false,
    advancedOptions: true,
    compositeKey: false,
    advSortOrder: 1
  },
  time_slot: {
    id: "time_slot",
    name: "Time Slot",
    show: false,
    advancedOptions: true,
    compositeKey: false,
    advSortOrder: 2
  },
  time_picker: {
    id: "time_picker",
    name: "Timepicker",
    show: false,
    advancedOptions: true,
    compositeKey: false,
    advSortOrder: 3
  },
  slug: {
    id: "slug",
    name: "Slug",
    show: false,
    advancedOptions: true,
    compositeKey: false,
    advSortOrder: 4
  },
  json: {
    id: "json",
    name: "JSON",
    show: false,
    advancedOptions: true,
    compositeKey: false,
    advSortOrder: 5
  },
  markdown: {
    id: "markdown",
    name: "Markdown",
    show: false,
    advancedOptions: true,
    compositeKey: false,
    advSortOrder: 6
  }
};
var _exports$FieldTypes = exports.FieldTypes,
  belongsTo = _exports$FieldTypes.belongsTo,
  boolean = _exports$FieldTypes.boolean,
  color = _exports$FieldTypes.color,
  createdAt = _exports$FieldTypes.createdAt,
  createdBy = _exports$FieldTypes.createdBy,
  custom_uuid = _exports$FieldTypes.custom_uuid,
  date = _exports$FieldTypes.date,
  dynamic_option = _exports$FieldTypes.dynamic_option,
  email = _exports$FieldTypes.email,
  file = _exports$FieldTypes.file,
  image = _exports$FieldTypes.image,
  isDeleted = _exports$FieldTypes.isDeleted,
  large_text = _exports$FieldTypes.large_text,
  multi_image = _exports$FieldTypes.multi_image,
  number = _exports$FieldTypes.number,
  object = _exports$FieldTypes.object,
  password = _exports$FieldTypes.password,
  reference = _exports$FieldTypes.reference,
  static_option = _exports$FieldTypes.static_option,
  tel = _exports$FieldTypes.tel,
  text = _exports$FieldTypes.text,
  uuid = _exports$FieldTypes.uuid,
  updatedAt = _exports$FieldTypes.updatedAt,
  url = _exports$FieldTypes.url,
  unix_timestamp = _exports$FieldTypes.unix_timestamp,
  video_link = _exports$FieldTypes.video_link,
  time_picker = _exports$FieldTypes.time_picker,
  time_slot = _exports$FieldTypes.time_slot,
  updatedBy = _exports$FieldTypes.updatedBy,
  version = _exports$FieldTypes.version;
exports.defaultFields = ["id", "uuid", "UUID", "created_at", "createdat", "createdAt", "created", "created time", "updated_at", "updatedat", "updatedAt", "updated", "last edited time", "created by", "isdeleted", "is_deleted", "is_delete", "isdelete", "delete", "updatedBy", "version"];
exports.crudKeys = ["create", "update", "detail", "list", "delete"];
var fieldType = function fieldType(itemName, type) {
  if (itemName === "custom_uuid") {
    return "uuid";
  }
  switch (type) {
    case "integer":
    case "autoNumber":
    case "phoneNumber":
    case "phone_number":
      type = "number";
      break;
    case "string":
    case "singleLineText":
    case "rich_text":
    case "title":
    case "multilineText":
    case "url":
    case "multipleAttachments":
      type = "text";
      break;
    case "checkbox":
      type = "boolean";
      break;
    case "multipleSelects":
    case "multi_select":
    case "status":
    case "select":
    case "singleSelect":
      type = "static_option";
      break;
    case "date":
      type = "date";
      break;
    default:
      break;
  }
  return type;
};
exports.fieldType = fieldType;
/** TWO */
exports.OptionTypeFields = [static_option.id, dynamic_option.id];
//Can be removed
exports.childDataField = [reference.id, dynamic_option.id];
exports.BelongsToReferenceField = [reference.id, belongsTo.id];
exports.ReferenceCreatedByFields = [reference.id, createdBy.id];
exports.ImageFields = [image.id, multi_image.id];
exports.URLFields = [image.id, file.id];
exports.FileUrlFields = [file.id, url.id];
exports.systemDateField = [updatedAt.id, createdAt.id];
exports.emailField = [text.id, email.id];
exports.passwordField = [text.id, password.id];
exports.uuidField = [text.id, uuid.id];
exports.exportHideField = [password.id, file.id];
exports.numberTextField = [number.id, tel.id];
exports.linkField = [tel.id, url.id];
exports.passwordUrlField = [password.id, url.id];
exports.largeTextNumberField = [large_text.id, number.id];
exports.booleanUrlField = [boolean.id, url.id];
exports.byFields = new Set([createdBy.id, updatedBy.id]);
exports.hiddenField = [createdBy.id, isDeleted.id, updatedBy.id, version.id];
exports.passwordBooleanField = [boolean.id, password.id];
exports.timeSlotPicker = [time_picker.id, time_slot.id];
exports.textNumberField = [text.id, number.id];
/** THREE */
exports.systemHideField = [].concat(_toConsumableArray(exports.hiddenField), [uuid.id]);
exports.hashCodeFieldText = [color.id, uuid.id, custom_uuid.id];
exports.textEmailPasswordField = [].concat(_toConsumableArray(exports.emailField), [password.id]);
exports.ImageUrlFields = [].concat(_toConsumableArray(exports.ImageFields), [file.id]);
exports.SelectOptionFields = [].concat(_toConsumableArray(exports.OptionTypeFields), [reference.id]);
exports.MultiSelectOptionFields = [].concat(_toConsumableArray(exports.OptionTypeFields), [belongsTo.id]);
exports.dateField = [].concat(_toConsumableArray(exports.systemDateField), [date.id]);
/** FOUR */
exports.TextTypeFields = [].concat(_toConsumableArray(exports.emailField), _toConsumableArray(exports.numberTextField));
exports.DefaultPrivateField = [].concat(_toConsumableArray(exports.systemHideField), [password.id]);
exports.BelongsCreatedByRefField = [].concat(_toConsumableArray(exports.BelongsToReferenceField), [createdBy.id]);
exports.BelongsSelectOptionFields = [].concat(_toConsumableArray(exports.SelectOptionFields), [createdBy.id, belongsTo.id]);
/** FIVE */
exports.stringField = [].concat(_toConsumableArray(exports.emailField), _toConsumableArray(exports.hashCodeFieldText));
exports.hiddenFormField = [].concat(_toConsumableArray(exports.systemHideField), _toConsumableArray(exports.systemDateField));
exports.normalTextField = [].concat(_toConsumableArray(exports.TextTypeFields), _toConsumableArray(exports.passwordUrlField));
exports.mixedField = [].concat(_toConsumableArray(exports.hashCodeFieldText), _toConsumableArray(exports.largeTextNumberField), [video_link.id, boolean.id]);
exports.stringLinkField = [].concat(_toConsumableArray(exports.stringField), _toConsumableArray(exports.linkField));
exports.nonExportField = [].concat(_toConsumableArray(exports.systemDateField), _toConsumableArray(exports.exportHideField));
exports.notFieldForImport = [].concat(_toConsumableArray(exports.hiddenFormField), _toConsumableArray(exports.ImageFields), [password.id]);
/** Usage of emailField */
exports.textTypeAndColorField = [].concat(_toConsumableArray(exports.TextTypeFields), [color.id]);
exports.pureTextField = [].concat(_toConsumableArray(exports.textTypeAndColorField), _toConsumableArray(exports.linkField));
exports.simpleTextField = [].concat(_toConsumableArray(exports.emailField), _toConsumableArray(exports.largeTextNumberField), _toConsumableArray(exports.booleanUrlField));
exports.NoRefFields = [].concat(_toConsumableArray(exports.textTypeAndColorField), [boolean.id]);
exports.textField1 = [].concat(_toConsumableArray(exports.TextTypeFields), _toConsumableArray(exports.booleanUrlField));
/** Usage of uuidField */
exports.pageCollectionFields = [].concat(_toConsumableArray(exports.uuidField), _toConsumableArray(exports.largeTextNumberField), [createdAt.id, boolean.id]);
exports.referenceTextField = [].concat(_toConsumableArray(exports.uuidField), _toConsumableArray(exports.childDataField), [number.id]);
/** Usage of textEmailPasswordField */
exports.StringFields = [].concat(_toConsumableArray(exports.textEmailPasswordField), _toConsumableArray(exports.linkField));
exports.placeholderField = [reference.id].concat(_toConsumableArray(exports.systemDateField), _toConsumableArray(exports.hiddenField), [password.id]);
/** Usage of  systemDateField and systemHideField */
exports.systemAndRefField = [].concat(_toConsumableArray(exports.systemHideField), _toConsumableArray(exports.childDataField));
exports.belongsToAndHiddenField = [].concat(_toConsumableArray(exports.BelongsToReferenceField), _toConsumableArray(exports.hiddenFormField));
/** Usage of BelongsToReferenceField */
exports.level3ReferenceField2 = [].concat(_toConsumableArray(exports.belongsToAndHiddenField), _toConsumableArray(exports.exportHideField));
exports.notFieldForExport = [].concat(_toConsumableArray(exports.nonExportField), _toConsumableArray(exports.hiddenField), [object.id]);
exports.level3ReferenceField = [].concat(_toConsumableArray(exports.BelongsCreatedByRefField), _toConsumableArray(exports.nonExportField), [isDeleted.id]);
/** Usage of OptionTypeFields */
exports.nonReferenceField = [].concat(_toConsumableArray(exports.stringLinkField), _toConsumableArray(exports.largeTextNumberField), _toConsumableArray(exports.passwordBooleanField), [video_link.id]);
exports.AllSelectOptionFields = [reference.id].concat(_toConsumableArray(exports.MultiSelectOptionFields));
var textField = [].concat(_toConsumableArray(exports.stringLinkField), _toConsumableArray(exports.passwordBooleanField), [number.id, date.id, unix_timestamp.id]);
exports.collectionDefaultFieldSortOrder = [{
  order: 1,
  field: uuid.id
}, {
  order: 2,
  field: createdAt.id
}, {
  order: 3,
  field: createdBy.id
}, {
  order: 4,
  field: updatedAt.id
}];
var filterFieldsForForm = function filterFieldsForForm(fields) {
  return fields.filter(function (field) {
    return !exports.hiddenFormField.includes(field.type);
  });
};
exports.filterFieldsForForm = filterFieldsForForm;
var filterFieldForCommandObj = function filterFieldForCommandObj() {
  return Object.keys(exports.FieldTypes).filter(function (field) {
    return ![].concat(_toConsumableArray(exports.systemDateField), _toConsumableArray(exports.systemAndRefField), _toConsumableArray(exports.ImageUrlFields), [belongsTo.id, static_option.id, color.id]).includes(field);
  });
};
exports.filterFieldForCommandObj = filterFieldForCommandObj;
var fieldToShow = function fieldToShow(type) {
  return !exports.systemAndRefField.includes(type);
};
exports.fieldToShow = fieldToShow;
var filterFieldsForDataTable = function filterFieldsForDataTable(fields) {
  return fields.filter(function (field) {
    return ![].concat(_toConsumableArray(exports.belongsToAndHiddenField), ["utility"]).includes(field.type) && field.id !== "";
  });
};
exports.filterFieldsForDataTable = filterFieldsForDataTable;
var filterFieldsForItemList = function filterFieldsForItemList(fields) {
  return fields.filter(function (field) {
    return ![].concat(_toConsumableArray(exports.systemHideField), [password.id]).includes(field.type);
  });
};
exports.filterFieldsForItemList = filterFieldsForItemList;
var filterSystemCreatedFieldsForItemList = function filterSystemCreatedFieldsForItemList(fields) {
  return fields.filter(function (field) {
    return field.type === createdAt.id;
  });
};
exports.filterSystemCreatedFieldsForItemList = filterSystemCreatedFieldsForItemList;
var filterFieldForItemTemplate = function filterFieldForItemTemplate(fieldName) {
  return [].concat(_toConsumableArray(exports.hiddenFormField), [reference.id], _toConsumableArray(exports.ImageFields)).includes(fieldName);
};
exports.filterFieldForItemTemplate = filterFieldForItemTemplate;
var filterFieldsForItemTemplate = function filterFieldsForItemTemplate(fields) {
  return fields.filter(function (field) {
    return [].concat(_toConsumableArray(exports.notFieldForImport), [reference.id]).includes(field.type);
  });
};
exports.filterFieldsForItemTemplate = filterFieldsForItemTemplate;
var filterFieldsForPlaceholderModal = function filterFieldsForPlaceholderModal(fields) {
  return fields.filter(function (field) {
    return !exports.placeholderField.includes(field.type);
  });
};
exports.filterFieldsForPlaceholderModal = filterFieldsForPlaceholderModal;
var filterIndexFields = function filterIndexFields(fields) {
  if (!fields || fields.length === 0) {
    return [];
  }
  return fields.filter(function (field) {
    return textField.includes(field.type);
  });
};
exports.filterIndexFields = filterIndexFields;